<template>
  <div
    class="mobile_vote"
    v-loading.fullscreen.lock="voteListLoading"
    :element-loading-text="this.$config.loadingText"
    :element-loading-spinner="this.$config.loadingSpinner"
    :element-loading-background="this.$config.loadingBackground"
  >
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="userOut()">
          <i class="el-icon-switch-button"></i>
          <span>退出</span>
        </a>
      </div>
      <span class="mobile_head_desc"> 全部投票 </span>
      <div class="mobile_head_right">
        <a @click="refresh_meeting()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_code">
        <a @click="onShowCode()">
          <i class="iconfont icon-erweima"></i>
        </a>
      </div>
      <div class="mobile_bar_name">
        {{ meetingInfo.MeetingName }}
      </div>
      <div class="mobile_bar_num">
        <span>共参加</span>
        <span class="vote_num">{{ meetingInfo.VoteItemsCount }}</span>
        <span>组投票</span>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div
        class="vote_item"
        :class="getStateBg(item)"
        v-for="(item, index) in meetingInfo.VoteItems"
        :key="index"
        @click="openVote(item)"
      >
        <div class="vote_item_content">
          <div class="vote_item_title" v-html="item.VoteName"></div>
          <div class="vote_item_num">
            <span v-if="item.IsShowProjectTitle">
              <i class="iconfont icon-daibiaodahui"></i>
              {{ item.VoterTitle }}：
              <span class="vote_item_num_count"
                >{{ item.SelectUserCount }}
              </span>
            </span>
            <span v-if="item.IsShowVoterTitle">
              <i class="el-icon-menu"></i>
              {{ item.ProjectTitle }}：
              <span class="vote_item_num_count">{{
                item.SelectProjectCount
              }}</span>
            </span>
            <span v-if="!item.IsShowProjectTitle">
              <span class="vote_item_num_count"> </span>
            </span>
            <span v-if="!item.IsShowVoterTitle">
              <span class="vote_item_num_count"> </span>
            </span>
          </div>
        </div>
        <div class="vote_item_open">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <el-image-viewer
      v-if="showCode"
      :on-close="closeCode"
      :url-list="MeetingCodeUrl"
    />
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
// 导入组件
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: { ElImageViewer },
  data () {
    return {
      voteListLoading: false,
      meetingInfo: {},
      MeetingCodeUrl: [],
      showCode: false,
      voteMainStyle: {
        marginTop: '65px'
      }
    }
  },
  methods: {
    userOut: function () {
      this.$confirm('确定退出本次会议吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        this.$router.push({ name: 'voteLogin', params: { mid: this.$route.params.mid, cid: this.meetingInfo.CompanyID } })
      }).catch(() => {

      })
    },
    getMeetingVoteInfo: function () {
      const _this = this
      _this.voteListLoading = true
      voteApi.getMeetingVoteInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        _this.meetingInfo = data
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })

        _this.voteListLoading = false
      }).catch(err => {
        _this.voteListLoading = false
        return err
      })
    },
    refresh_meeting: function () {
      this.getMeetingVoteInfo()
    },
    onShowCode: function () {
      this.MeetingCodeUrl = []
      this.MeetingCodeUrl.push(this.meetingInfo.MeetingCodeWeb)
      this.MeetingCodeUrl.push(this.meetingInfo.MeetingCode)
      this.showCode = true
    },
    // 关闭查看器
    closeCode: function () {
      this.showCode = false
    },
    getStateBg: function (item) {
      switch (item.Status) {
        case 0:
          return 'nostart_bg'
        case 1:
          return 'inprogress_bg'
        case 3:
          return 'ended_bg'
        case 4:
          return 'closed_bg'
      }
    },
    openVote: function (item) {
      switch (item.VoteType) {
        case 0:
          if (item.IsChair) {
            this.$router.push({ name: 'chairShortlistedScreen', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsScrutineer) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsWatchVote) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else {
            this.$router.push({ name: 'shortlist', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          }
          break
        case 1:
          if (item.IsScrutineer) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsWatchVote) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else {
            this.$router.push({ name: 'sort', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          }
          break
        case 2:
          if (item.IsScrutineer) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsWatchVote) {
            this.$router.push({ name: 'mobileWatchVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else {
            this.$router.push({ name: 'score', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          }
          break
        case 3:
          if (item.IsChair) {
            this.$router.push({ name: 'chairScreenProjects', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsScrutineer) {
            this.$router.push({ name: 'mobileWatchScreenVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else if (item.IsWatchVote) {
            this.$router.push({ name: 'mobileWatchScreenVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          } else {
            this.$router.push({ name: 'judgeVote', params: { mid: this.$route.params.mid, vid: item.VoteID } })
          }
          break
      }
    }
  },
  mounted () {
    this.getMeetingVoteInfo()
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
</style>
